<template>
  <v-container fluid class="elegant-container">
    <v-row>
      <v-col cols="12">
        <h2 class="elegant-title">화상전화 앱 사용 방법</h2>
      </v-col>
      
      <v-col cols="12">
        <!-- Guide Cards in 3-Column Grid -->
        <v-row>
          <v-col cols="12" md="4" class="mb-4">
            <v-card class="guide-card h-100" elevation="2">
              <v-card-title class="guide-header d-flex align-center">
                <v-img 
                  :src="`${app.cdnUrl}/website/button/btn_zoom.png`"
                  max-width="32px"
                  max-height="32px"
                  class="mr-3 rounded app-logo"
                />
                <span class="title-text">Zoom</span>
              </v-card-title>
              
              <v-card-text class="pa-3">
                <!-- App Installation - Horizontal Layout -->
                <div class="guide-item">
                  <div class="guide-item-wrapper">
                    <div class="icon-wrapper">
                      <v-icon color="primary" size="18">mdi-download</v-icon>
                    </div>
                    <div class="content-wrapper">
                      <h5 class="item-title mb-1">App 설치</h5>
                      <v-btn 
                        class="text-none download-btn mt-1" 
                        color="primary"
                        small
                        outlined
                        @click="openWindow('https://zoom.us/download')"
                      >
                        Download
                      </v-btn>
                    </div>
                  </div>
                </div>
                
                <v-divider class="my-2"></v-divider>
                
                <!-- Registration - Horizontal Layout -->
                <div class="guide-item">
                  <div class="guide-item-wrapper">
                    <div class="icon-wrapper">
                      <v-icon color="primary" size="18">mdi-account-plus</v-icon>
                    </div>
                    <div class="content-wrapper">
                      <h5 class="item-title mb-1">회원가입</h5>
                      <a 
                        type="button"
                        @click="openWindow('https://zoom.us/google_oauth_signin')"
                      >
                        <v-img 
                          :src="`${app.cdnUrl}/website/button/google-signin-button.png`"
                          width="150px" 
                          height="32px"
                          class="mt-1"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                
                <v-divider class="my-2"></v-divider>
                
                <!-- Friend Request - Horizontal Layout -->
                <div class="guide-item">
                  <div class="guide-item-wrapper">
                    <div class="icon-wrapper">
                      <v-icon color="primary" size="18">mdi-account-check</v-icon>
                    </div>
                    <div class="content-wrapper">
                      <h5 class="item-title mb-1">친구요청</h5>
                      <p class="item-desc">선생님이 친구요청 보내드리면 Zoom 앱에서 수락 부탁드립니다.</p>
                    </div>
                  </div>
                </div>
                
                <!-- Screenshot examples -->
                <div class="mt-3">
                  <v-row dense>
                    <v-col cols="6">
                      <v-img 
                        :src="`${app.cdnUrl}/website/guide/zoom-accept-1.jpg`" 
                        width="100%"
                        class="guide-img"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-img 
                        :src="`${app.cdnUrl}/website/guide/zoom-accept-2.jpg`" 
                        width="100%"
                        class="guide-img"
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          
          <v-col cols="12" md="4" class="mb-4">
            <v-card class="guide-card h-100" elevation="2">
              <v-card-title class="guide-header d-flex align-center">
                <v-img
                  :src="`${app.cdnUrl}/website/button/btn_teams.png`"
                  max-width="32px"
                  max-height="32px"
                  class="mr-3 rounded app-logo"
                />
                <span class="title-text">Teams</span>
              </v-card-title>
              
              <v-card-text class="pa-3">
                <!-- App Installation - Horizontal Layout -->
                <div class="guide-item">
                  <div class="guide-item-wrapper">
                    <div class="icon-wrapper">
                      <v-icon color="primary" size="18">mdi-download</v-icon>
                    </div>
                    <div class="content-wrapper">
                      <h5 class="item-title mb-1">App 설치</h5>
                      <v-btn 
                        class="text-none download-btn mt-1" 
                        color="primary"
                        small
                        outlined
                        @click="openWindow('https://www.microsoft.com/ko-kr/microsoft-teams/download-app')"
                      >
                        Download
                      </v-btn>
                    </div>
                  </div>
                </div>
                
                <v-divider class="my-2"></v-divider>
                
                <!-- Account Sharing - Horizontal Layout -->
                <div class="guide-item">
                  <div class="guide-item-wrapper">
                    <div class="icon-wrapper">
                      <v-icon color="primary" size="18">mdi-account-arrow-right</v-icon>
                    </div>
                    <div class="content-wrapper">
                      <h5 class="item-title mb-1">계정 공유</h5>
                      <p class="item-desc">선생님에게 Teams 계정을 공유해주시면 전화드립니다.</p>
                    </div>
                  </div>
                </div>
                
                <!-- Screenshot examples -->
                <div class="mt-3">
                  <v-row dense>
                    <v-col cols="6">
                      <v-img
                        :src="`${app.cdnUrl}/website/guide/skype1.jpeg`"
                        width="100%"
                        class="guide-img"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-img
                        :src="`${app.cdnUrl}/website/guide/skype2.jpeg`"
                        width="100%"
                        class="guide-img"
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          

        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'About',
  props:{
    appType: {type: String, default: ''}
  },
  data: () => ({
    teams: '## [Teams 다운로드](https://www.microsoft.com/ko-kr/microsoft-teams/download-app)\n' +
        `![Teams](${this.app.cdnUrl}/website/guide/get_skype_id.jpg)`,
  }),
  components: {  },
  computed: {
    ...mapGetters(['app']),
  },
  created() { },
  methods: {
    openWindow(link) {
      this.$openWindow(link, 'book')
    },
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/main.scss";
@import "@/assets/scss/elegant-theme.scss";

.guide-card {
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1) !important;
  }
  
  .guide-header {
    background-color: #f8f9fa;
    padding: 12px 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }
  
  .title-text {
    font-size: 1.1rem;
    font-weight: 600;
    color: var(--v-primary-base);
  }
}

.guide-item {
  margin-bottom: 6px;
  
  .guide-item-wrapper {
    display: flex;
    align-items: flex-start;
    padding: 8px 0;
  }
  
  .icon-wrapper {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: rgba(59, 130, 246, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    flex-shrink: 0;
  }
  
  .content-wrapper {
    flex: 1;
  }
  
  .item-title {
    font-size: 0.9rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 2px;
  }
  
  .item-desc {
    font-size: 0.8rem;
    color: #666;
    margin-bottom: 0;
    line-height: 1.3;
  }
}

.app-logo {
  border-radius: 6px;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
  }
}

.guide-img {
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 8px;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: scale(1.02);
  }
}

.download-btn {
  transition: all 0.3s ease;
  font-size: 0.8rem;
  
  &:hover {
    transform: translateY(-2px);
  }
}

// Dark mode support
.theme--dark {
  .guide-card {
    .guide-header {
      background-color: #252525;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }
    
    .item-title {
      color: #e0e0e0;
    }
    
    .item-desc {
      color: #b0b0b0;
    }
    
    .icon-wrapper {
      background-color: rgba(59, 130, 246, 0.2);
    }
  }
}

@media (max-width: 600px) {
  .guide-card {
    .title-text {
      font-size: 1rem;
    }
    
    .guide-header {
      padding: 10px 12px;
    }
  }
  
  .guide-item {
    .guide-item-wrapper {
      padding: 6px 0;
    }
    
    .icon-wrapper {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
    
    .item-title {
      font-size: 0.85rem;
    }
    
    .item-desc {
      font-size: 0.75rem;
    }
  }
  
  .download-btn {
    font-size: 0.75rem;
  }
}
</style>